module.exports = __webpack_public_path__ + "img/3.f60dbba3.png";